"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var CommonBankAccountValidator_1 = __importDefault(require("../CommonBankAccountValidator"));
var BradescoCheckNumberCalculator_1 = require("./CheckNumber/BradescoCheckNumberCalculator");
var BradescoValidator = /** @class */ (function (_super) {
    __extends(BradescoValidator, _super);
    function BradescoValidator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BradescoValidator.prototype.agencyCheckNumberIsValid = function (agencyCheckNumber) {
        if (!agencyCheckNumber)
            return true;
        return agencyCheckNumber.length === this.agencyCheckNumberLength() && _super.prototype.agencyCheckNumberIsValid.call(this, agencyCheckNumber);
    };
    BradescoValidator.prototype.accountNumberIsValid = function (accountNumber) {
        return accountNumber.length === this.accountNumberLength() && _super.prototype.accountNumberIsValid.call(this, accountNumber);
    };
    BradescoValidator.prototype.agencyCheckNumberMatch = function (bankAccount) {
        if (!bankAccount.agencyCheckNumber)
            return true;
        var checkNumberCalculated = BradescoCheckNumberCalculator_1.BradescoCheckNumberCalculator.calculateAgency(bankAccount.agencyNumber);
        var checkNumberInformed = bankAccount.agencyCheckNumber.toUpperCase();
        if (checkNumberInformed === "0") {
            return checkNumberCalculated === checkNumberInformed || checkNumberCalculated === "P";
        }
        return checkNumberCalculated === checkNumberInformed;
    };
    BradescoValidator.prototype.accountCheckNumberMatch = function (bankAccount) {
        var checkNumberCalculated = BradescoCheckNumberCalculator_1.BradescoCheckNumberCalculator.calculateAccount(bankAccount.accountNumber);
        var checkNumberInformed = bankAccount.accountCheckNumber.toUpperCase();
        if (checkNumberInformed === "0") {
            return checkNumberCalculated === checkNumberInformed || checkNumberCalculated === "P";
        }
        return checkNumberCalculated === checkNumberInformed;
    };
    BradescoValidator.prototype.agencyCheckNumberLength = function () {
        return 1;
    };
    BradescoValidator.prototype.accountNumberLength = function () {
        return 7;
    };
    return BradescoValidator;
}(CommonBankAccountValidator_1.default));
exports.default = BradescoValidator;
//# sourceMappingURL=BradescoValidator.js.map